import { api } from "@/lib/api";

/* 🌍 Country detection + flag helpers for the leaderboards.
   Country is detected ONCE per device (IP-based, cached) and attached to the
   trader's public profile so boards can show their flag. */

export const flagEmoji = (cc) => {
  if (!cc || cc.length !== 2) return "";
  return cc.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
};

const CACHE_KEY = "vts_country_v1";

const detectCountry = async () => {
  const cached = localStorage.getItem(CACHE_KEY);
  if (cached) return cached;
  for (const probe of [
    { url: "https://ipapi.co/json/", pick: (d) => d.country_code },
    { url: "https://ipwho.is/", pick: (d) => d.country_code },
  ]) {
    try {
      const r = await fetch(probe.url);
      const cc = probe.pick(await r.json());
      if (cc && cc.length === 2) {
        localStorage.setItem(CACHE_KEY, cc.toUpperCase());
        return cc.toUpperCase();
      }
    } catch { /* try next provider */ }
  }
  return null;
};

export const ensureCountry = async (accountId) => {
  if (!accountId) return;
  const sentKey = `vts_country_sent_${accountId}`;
  if (localStorage.getItem(sentKey)) return;
  const cc = await detectCountry();
  if (!cc) return;
  try {
    await api.post("/profile/country", { account_id: accountId, country: cc });
    localStorage.setItem(sentKey, cc);
  } catch { /* retried on next visit */ }
};
